var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1070_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58268 2.875H13.416C15.4493 2.875 17.3994 3.68274 18.8372 5.12051C20.2749 6.55829 21.0827 8.50834 21.0827 10.5417C21.0827 12.575 20.2749 14.525 18.8372 15.9628C17.3994 17.4006 15.4493 18.2083 13.416 18.2083V21.5625C8.62435 19.6458 1.91602 16.7708 1.91602 10.5417C1.91602 8.50834 2.72375 6.55829 4.16153 5.12051C5.59931 3.68274 7.54936 2.875 9.58268 2.875ZM11.4993 16.2917H13.416C14.1711 16.2917 14.9188 16.1429 15.6164 15.854C16.3141 15.565 16.9479 15.1415 17.4819 14.6075C18.0158 14.0736 18.4394 13.4397 18.7283 12.7421C19.0173 12.0445 19.166 11.2968 19.166 10.5417C19.166 9.78657 19.0173 9.03886 18.7283 8.34124C18.4394 7.64361 18.0158 7.00974 17.4819 6.4758C16.9479 5.94187 16.3141 5.51832 15.6164 5.22936C14.9188 4.94039 14.1711 4.79167 13.416 4.79167H9.58268C8.05769 4.79167 6.59515 5.39747 5.51682 6.4758C4.43848 7.55414 3.83268 9.01667 3.83268 10.5417C3.83268 14.0012 6.1921 16.2591 11.4993 18.6683V16.2917Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.70898,
    y: 9.58301,
    width: 1.91667,
    height: 1.91667,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.375,
    y: 9.58301,
    width: 1.91667,
    height: 1.91667,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.541,
    y: 9.58301,
    width: 1.91667,
    height: 1.91667,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1070_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.a264a8788445add2995fb85608547528.svg";
export { ForwardRef as ReactComponent };